<p>profile</p>
<pre> {{ profile | json }}</pre>
